/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const SectionFooterText = styled.h4`
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-transform: none;
`;
export const IconWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionContainer = styled.div`
  .MuiAccordionActions-root {
    justify-content: flex-start;
    display: flex;
    align-items: center;
    height: 48px;
    background: ${Palette.PrimaryGray._000};
    border-radius: 0px 0px 8px 8px;
    cursor: pointer;
    svg {
      fill: ${Palette.PrimaryGray._400};
    }
    color: ${Palette.PrimaryGray._700};
    :hover {
      background: ${Palette.PrimaryGray._200};
      svg {
        fill: ${Palette.PrimaryGray._500};
      }
    }
    :active {
      background: ${Palette.PrimaryGray._000};
      color: ${Palette.PrimaryGray._900};
      svg {
        fill: ${Palette.PrimaryGray._900};
      }
    }
    ${({ disabled }) => {
      return (
        disabled &&
        css`
          opacity: 0.5;
          cursor: not-allowed;
          background-color: ${Palette.PrimaryGray._000};
          color: ${Palette.PrimaryGray._700};
          svg {
            fill: ${Palette.PrimaryGray._500};
          }
          :hover {
            background-color: ${Palette.PrimaryGray._000};
            color: ${Palette.PrimaryGray._700};
            svg {
              fill: ${Palette.PrimaryGray._500};
            }
          }
        `
      );
    }}
  }
`;
